import { canUseDOM } from 'exenv';

export default function adtoniq() {
  if (canUseDOM) {
    return `
    <iframe
      src="https://drlimmode9ddd.cloudfront.net/f/3eJyrVspUslJQMjQxNlLSUVAqB3HSEotLkvNzCxLzKvWANEi8BCwOYuXnpcZn5gG5hrUA4rMQYA====/1432.html"
      style="position: absolute; left: -10px; width: 1px; height: 1px;"
    ></iframe>`;
  }
  return '';
}
